var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/travis/build/SouthAmericansSecrets/web/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["partials/tours-page.es.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += " <div class=\"col-md-12\">\n\t<div class=\"row tour-container\">\n\t\t<div class=\"col-md-8 col-sm-12 white\">\n\t\t\t<img class=\"article-image tour-image\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"url_image"), env.opts.autoescape);
output += "\" alt=\"\" width=\"100%\">\n\t\t\t<p class=\"text-justify\">\n\t\t\t\t<div class=\"article-title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
output += "</div>\n\t\t\t\t<div class=\"article-subtitle\">\n\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"subtitle"), env.opts.autoescape);
output += "\n\t\t\t\t</div>\n\t\t\t\t<p style=\"padding: 0 15px; \">\n\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"description"), env.opts.autoescape);
output += "\n\t\t\t\t</p>\n\t\t\t</p>\n\t\t</div>\n\t\t<div class=\"col-md-4 hidden-sm hidden-xs\">\n\t\t\t\t\t <div class=\"banner-right floating-right tour-menu\">\n\t\t\t\t\t\t\t <ul>\n\t\t\t\t\t\t\t\t\t ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"tours");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t\t\t\t\t\t\t\t\t <li><a href=\"#";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"shortTitle"), env.opts.autoescape);
output += "</a></li>\n\t\t\t\t\t\t\t\t\t ";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t\t\t\t <li><a href=\"#additional-info\">Additional Information</a></li>\n\t\t\t\t\t\t\t </ul>\n\t\t\t\t\t </div>\n\t\t</div>\n\t</div>\n\n\t\t";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"tours");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n\t\t <div class=\"row tour-container ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"classes"), env.opts.autoescape);
output += "\" >\n\t\t\t\t<div class=\"col-md-8 tour-info\">\n\t\t\t\t";
if(runtime.memberLookup((t_8),"classes")) {
output += "\n            \t\t<div class=\"corner-ribbon top-left sticky orange shadow\"><i class=\"fa fa-ship\" aria-hidden=\"true\"></i> Miembros de crucero</div>\n        \t\t";
;
}
output += "\n\t\t\t\t\t<p class=\"text-justify\">\n\t\t\t\t\t\t\t\t<img class=\"tour-image\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"url_image"), env.opts.autoescape);
output += "\" alt=\"\">\n\n\t\t\t\t\t\t\t\t<div class=\"article-title\" id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</div>\n\t\t\t\t\t\t<div class=\"article-subtitle\">\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_8),"subtitle"), env.opts.autoescape);
output += "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p style=\"padding: 0 15px; \">\n\t\t\t\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_8),"description")), env.opts.autoescape);
output += "\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"slick-autoplay\">\n\t\t\t\t\t\t";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"gallery");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("image", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n\t\t\t\t\t\t\t<a href=\"";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "\">\n\t\t\t\t\t\t\t\t<img src=\"";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "\" height=\"50px\" width=\"50px\"/>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t</div>\n\t\t\t\t\t";
if(runtime.memberLookup((t_8),"certs")) {
output += "\n\t\t\t\t\t<div class=\"spacer\">\n\t\t\t\t\t\t<h3>Certificados de excelencia</h3>\n\t\t\t\t\t\t<div class=\"certs\">\n\t\t\t\t\t\t\t";
frame = frame.push();
var t_15 = runtime.memberLookup((t_8),"certs");
if(t_15) {t_15 = runtime.fromIterator(t_15);
var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("cert", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n\t\t\t\t\t\t\t\t<img src=\"";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "\">\n\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t<div class=\"banner-right floating-right\">\n\t\t\t\t\t\t<div class=\"tour-detail\">\n\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_8),"yacht")) {
output += "\n\t\t\t\t\t\t\t\t\t<img src=\"images/";
output += runtime.suppressValue(runtime.memberLookup((t_8),"yacht"), env.opts.autoescape);
output += "\" align=\"right\" width=\"60\" style=\"margin-top: -22.5px; margin-right: -32.5px\">\n\t\t\t\t\t\t\t\t";
;
}
output += "\n\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"activities")) {
output += "\n                    <div class=\"tour-info-title\">Actividades</div>\n                    <ul>\n                    ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"activities");
if(t_19) {t_19 = runtime.fromIterator(t_19);
var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("activity", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\n                        <li>\n                        ";
output += runtime.suppressValue(t_20, env.opts.autoescape);
output += "\n                        </li>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n                ";
;
}
output += "\n\t\t\t\t\t\t\t\t<div class=\"tour-info-title\">Incluye</div>\n\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"include");
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("inc", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\n\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(t_24, env.opts.autoescape);
output += "\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<div class=\"tour-info-title\">No Incluye</div>\n\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_27 = runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"notInclude");
if(t_27) {t_27 = runtime.fromIterator(t_27);
var t_26 = t_27.length;
for(var t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25];
frame.set("inc", t_28);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
output += "\n\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(t_28, env.opts.autoescape);
output += "\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<div class=\"tour-info-title\">Duración <small>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"duration")),"subtitle"), env.opts.autoescape);
output += "</small></div>\n\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_31 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"duration")),"data");
if(t_31) {t_31 = runtime.fromIterator(t_31);
var t_30 = t_31.length;
for(var t_29=0; t_29 < t_31.length; t_29++) {
var t_32 = t_31[t_29];
frame.set("inc", t_32);
frame.set("loop.index", t_29 + 1);
frame.set("loop.index0", t_29);
frame.set("loop.revindex", t_30 - t_29);
frame.set("loop.revindex0", t_30 - t_29 - 1);
frame.set("loop.first", t_29 === 0);
frame.set("loop.last", t_29 === t_30 - 1);
frame.set("loop.length", t_30);
output += "\n\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += "\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t\t\t</ul>\n\n                <div class=\"tour-info-title\">";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"base_price")?"Precio base:":"Precio:"), env.opts.autoescape);
output += " <small>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"currency"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"ammount"), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"per_hour")?" por hora":""), env.opts.autoescape);
output += "</small></div>\n\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_35 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"data");
if(t_35) {t_35 = runtime.fromIterator(t_35);
var t_34 = t_35.length;
for(var t_33=0; t_33 < t_35.length; t_33++) {
var t_36 = t_35[t_33];
frame.set("inc", t_36);
frame.set("loop.index", t_33 + 1);
frame.set("loop.index0", t_33);
frame.set("loop.revindex", t_34 - t_33);
frame.set("loop.revindex0", t_34 - t_33 - 1);
frame.set("loop.first", t_33 === 0);
frame.set("loop.last", t_33 === t_34 - 1);
frame.set("loop.length", t_34);
output += "\n\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(t_36, env.opts.autoescape);
output += "\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<button class=\"bttn-unite bttn-md bttn-warning\" data-toggle=\"modal\" data-target=\"#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "-modal\">Reservar Tour</button>\n\n<div class=\"share dropdown share-tours\">\n    <button class=\"btn read-more dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n       ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "share"), env.opts.autoescape);
output += " <i class=\"fa fa-share\" aria-hidden=\"true\"></i>\n    </button>\n    <ul class=\"dropdown-menu dropdown-menu-right\">\n        <div id=\"share-buttons\">\n            <a href=\"http://www.facebook.com/sharer.php?u=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += "#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/facebook.png\" alt=\"Facebook\" />\n            </a>\n            <a href=\"https://plus.google.com/share?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += "#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/google.png\" alt=\"Google\" />\n            </a>\n            <a href=\"http://www.linkedin.com/shareArticle?mini=true&amp;url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += "#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/linkedin.png\" alt=\"LinkedIn\" />\n            </a>\n            <a href=\"http://reddit.com/submit?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += "#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "&amp;title=South Americans Secrets\" target=\"_blank\">\n                <img src=\"images/reddit.png\" alt=\"Reddit\" />\n            </a>\n            <a href=\"https://twitter.com/share?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += "#";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "&amp;text=South%20Americans%20Secrets&amp;hashtags=southamericanssecrets\" target=\"_blank\">\n                <img src=\"images/twitter.png\" alt=\"Twitter\" />\n            </a>\n        </div> \n    </ul>\n</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n    \t<!-- Modal -->\n    <div id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "-modal\" class=\"rsv-modal-only modal\" role=\"dialog\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button>\n                    <h3 class=\"modal-title\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"form_title") || runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</h3>\n                    <div class=\"price-holder\"><span class=\"form_price\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"ammount"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"additionalData")),"price")),"currency"), env.opts.autoescape);
output += "</span><span> por persona</span></div>\n                </div>\n                <div class=\"modal-body\">\n\t\t\t\t\t<input type=\"hidden\" id=\"rsv-tour-info\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "\" tour-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\">\n\t\t\t\t\t<input type=\"hidden\" id=\"rsv-lang\" value=\"es\">\n                    <div class=\"reservation-subtitle\">Reservación de tour</div>\n                    <div class=\"form-inputs\"><input type=\"text\" class=\"rsv-input\" id=\"rsv-name\" placeholder=\"Nombre*\"></div>\n                    <div class=\"input-group date-input-group\">\n                        <span class=\"input-group-addon\">Fecha*</span>\n                        <input type=\"date\" id=\"rsv-date\" class=\"form-control rsv-date\" name=\"date\">\n                    </div>\n                    <div class=\"form-inputs\"><input id=\"rsv-people\" placeholder=\"N° personas*\" class=\"rsv-input\" type=\"number\"></div>\n                    <div class=\"form-inputs\"><input id=\"rsv-email\" placeholder=\"Correo Electrónico*\" class=\"rsv-input rsv-email\" type=\"email\"></div>\n\t\t\t\t\t<div class=\"input-group\">\n\t\t\t\t\t\t<span class=\"input-group-addon\">Forma de pago*</span>\n\t\t\t\t\t\t<select id=\"rsv-payment\" class=\"form-control\">\n\t\t\t\t\t\t\t<option value=\"visa-credit\">Visa crédito</option>\n\t\t\t\t\t\t\t<option value=\"visa-debit\">Visa débito</option>\n\t\t\t\t\t\t\t<option value=\"paypal\">Paypal</option>\n\t\t\t\t\t\t\t<option value=\"bank-transfer\">Transferencia bancaria</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n                    <div class=\"form-inputs\"><textarea id=\"rsv-notes\" class=\"rsv-notes\" placeholder=\"Notas de su reservación\"></textarea></div>\n\t\t\t\t\t<p id=\"rsv-warn\" class=\"rsv-warn-regular rsv-warn rsv-warn-hidden\">*Solicitud inválida, debe llenar todos los campos obligatorios*</p>\n\t\t\t\t\t<p id=\"rsv-warn-email\" class=\"rsv-warn rsv-warn-hidden\">*Dirección de correo electrónico inválida*</p>\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" parent-modal=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "-modal\" id=\"request-reservation\" class=\"request-reservation btn btn-default request-btn\"><i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i>  Solicitar Reservación</button>\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cerrar</button>\n                </div>\n          </div>\n        </div>\n    </div>\n\t\t";
;
}
}
frame = frame.pop();
output += "\n    <!-- Modal -->\n    <div id=\"sent-reservation\" class=\"modal\" role=\"dialog\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button>\n                    <h3 class=\"modal-title\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Solicitud Enviada</h3>\n                    <div class=\"price-holder\"><span class=\"form_price\">Pronto lo contactaremos</span></div>\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default request-btn\" data-dismiss=\"modal\">Ok</button>\n                </div>\n          </div>\n        </div>\n    </div>\n\t\t<hr/>\n <div class=\"row additional-info\">\n\t\t<div class=\"col-md-12\">\n\t\t\t<h2 id=\"additional-info\">Información Adicional</h2>\n\t\t\t<ul>\n\t\t\t\t\t<li>Se requiere toda su información personal en el momento de su reserva.</li>\n\t\t\t\t\t<li>La confirmación de la excursión será recibido en el momento de la reserva.</li>\n\t\t\t\t\t<li>Todos los tours son operados en español a menos que se indique lo contrario.</li>\n\t\t\t</ul>\n\n\t\t\t<h4>Voucher de Viaje:</h4>\n\t\t\t<ul>\n\t\t\t\t<li>Usted recibirá un voucher electrónico a través de correo electrónico una vez que se confirma la reserva.</li>\n\t\t\t\t<li>Para cada reserva confirmada se le requiere para imprimir el voucher electrónico para la presentación al inicio de la excursión.</li>\n\t\t\t\t<li>El voucher electrónico actúa como una confirmación de todos los servicios que usted solicitó.</li>\n\t\t\t</ul>\n\n\t\t\t<h4>Información del operador local:</h4>\n\t\t\t<ul>\n\t\t\t\t<li>Le enviaremos la información completa del operador, incluyendo los números de teléfono en su destino.</li>\n\t\t\t\t<li>Nuestros gestores solo seleccionan a los operadores más fiables y expertos en cada destino, para ahorrarle trabajo a usted, y que garanticen su tranquilidad.</li>\n\t\t\t</ul>\n\n\t\t</div>\n </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["partials/tours-page.es.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./app/tpl/partials/tours-page.es.njk
// module id = 60
// module chunks = 50 51 52 53 57 58 59 60 61 62 63 64